import { defineComponent as _defineComponent } from 'vue'
import IconInfoCircle from '@/_legacy/components/Icons/IconInfoCircle.vue';
  import { InputField } from '@/ui/components/form/InputField';
  import { Field } from '@/ui/components/form/Field';
  import { CourseItem } from '@/entities/trainings';
  import Editor from '@/ui/components/richText/Editor.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TextComponent',
  props: {
    item: {
      type: Object as () => CourseItem,
      required: true,
    },
  },
  emits: ['update:title', 'update:description'],
  setup(__props, { emit }) {

  

  

  const updateTitle = (value: string) => {
    emit('update:title', value);
  };

  const updateDescription = (value: string) => {
    emit('update:description', value);
  };

return { __sfc: true,emit, updateTitle, updateDescription, IconInfoCircle, InputField, Field, Editor }
}

})